import { render, staticRenderFns } from "./ImportItem.vue?vue&type=template&id=9bff38b8&scoped=true&"
import script from "./ImportItem.vue?vue&type=script&lang=ts&"
export * from "./ImportItem.vue?vue&type=script&lang=ts&"
import style0 from "./ImportItem.vue?vue&type=style&index=0&id=9bff38b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bff38b8",
  null
  
)

export default component.exports